module.exports = __webpack_public_path__ + "static/img/landing_button2.71956db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing_button2.gif
// module id = qh94
// module chunks = 1